/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_sku = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
    readonly " $refType": "PdpRespSidebarBlurbShipping_sku";
};
export type PdpRespSidebarBlurbShipping_sku$data = PdpRespSidebarBlurbShipping_sku;
export type PdpRespSidebarBlurbShipping_sku$key = {
    readonly " $data"?: PdpRespSidebarBlurbShipping_sku$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};
(node as any).hash = '0b39b2dde9ee83e734ff2726bfa413cd';
export default node;
